import 'core-js';
import "regenerator-runtime/runtime";
import React from 'react';
import ReactDOM from 'react-dom';
import 'whatwg-fetch';

import QuizzWidgetAppRouter from './routers/QuizzWidgetAppRouter';
import { BlendAppQuizzDataContextProvider } from './contexts/blendAppQuizzData-context';

require('babel-polyfill');

ReactDOM.render(
    <BlendAppQuizzDataContextProvider>
        <QuizzWidgetAppRouter/>
    </BlendAppQuizzDataContextProvider>
    , 
    document.getElementById('QuizzWidgetApp')
);
